import React, { useState } from "react";

const TokenAddress = () => {
  const address = "0xb692e9099a6b275cfc990c994f0d62cca2284444";
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(address);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const truncated = `${address.slice(0, 6)}...${address.slice(-4)}`;

  return (
    <button
      onClick={handleCopy}
      className="w-[200px] flex items-center justify-center bg-[#f452c9] hover:bg-[#ff73d4] px-6 py-3 rounded-full font-semibold text-white text-sm md:text-base shadow-md transition-all duration-300"
      title="Click to copy full token address"
    >
      {copied ? "Copied!" : truncated}
    </button>
  );
};

export default TokenAddress;
